(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('ScheduleTestIssuesController', ScheduleTestIssuesController);
    ScheduleTestIssuesController.$inject = ['$uibModalInstance','VirtualFairService','representative'];

    function ScheduleTestIssuesController($uibModalInstance,VirtualFairService, representative) {

        var vm                  = this;
        vm.cancel               = cancel;
        vm.newIssue             = '';
        vm.saveIssue            = saveIssue;
        vm.sellerSelected       = '';
        vm.representative       = representative;
        vm.updateTestStatus     = updateTestStatus;

        function cancel() {
            $uibModalInstance.close();
        }

        function active(){
        }

        function saveIssue() {

            vm.query = {};
            vm.query['issue']                       = vm.newIssue;
            vm.query['representative_id']           = vm.representative.id;
            VirtualFairService.storeTestIssue(vm.query).then(function(response){
                vm.representative.issues[response.id] = {'id' : response.id, 'description' : response.description, 'created_at' : response.created_at};
                vm.newIssue = '';
            }).catch(function(err) {
            });
        }
        function updateTestStatus() {
            alertify
                .confirm(representative.is_tested == 0 ? 'Did you really confirm that all tests were COMPLETED?' : 'Did you really confirm that all tests were PENDING?')
                .set('labels', {
                    ok: 'OK',
                    cancel: 'CANCEL'
                })
                .set('title', 'Confirmation')
                .set('onok', function (){
                    vm.query = {};
                    vm.query['id'] = representative.id;
                    vm.query['is_tested'] = representative.is_tested;
                    VirtualFairService.updateTestStatus(vm.query).then(function(response) {
                        representative.is_tested = response;
                        console.log(response);
                        alertify.notify('Test status is successfully changed!', 'success', 3);
                    });
                })
                .show();
        }
        active();
    }

})();